<template>
  <div
    v-if="msgObject"
    class="message-card"
    :class="{
      isBySelf: isBySelf,
      recommendCard: props.customEvent === '29201',
      widthAuto: ['50901'].includes(props.customEvent)
    }"
  >
    <div class="card" v-if="props.customEvent === '22113'">
      <div class="card-header">用药建议</div>
      <div class="card-body">{{ props.msgObject.content }}</div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 病情描述 -->
    <div class="card" v-if="props.customEvent === '21001'">
      <div class="card-header">病情描述</div>
      <div class="card-body">请填写病情描述，以便快速了解您的病情</div>
    </div>
    <!-- 电话咨询卡片 -->
    <div class="card" v-if="props.customEvent === '50021'">
      <ConsultCard :info="props.msgObject"></ConsultCard>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 门诊病历 预病历 -->
    <div class="card" v-if="['21002'].includes(props.customEvent)">
      <div class="card-header">
        门诊病历
        <span>
          （{{ props.msgObject.patientName }}
          {{ Config.GENDER[props.msgObject.patientGender] || '-' }}
          {{ props.msgObject.patientAge ? `${props.msgObject.patientAge}岁` : '-' }}）
        </span>
      </div>
      <div class="card-body">
        <div v-for="(c, index) in medicalInfoList" :key="index">
          <div v-if="c.tag && c.tag === 'archiveFlag' && c.value === '0'" class="medical-info">
            <div class="label">{{ c.key }}</div>
            <div class="detail elip--multiple" style="-webkit-line-clamp: 1">未建档</div>
          </div>
          <div v-else-if="c.tag !== 'archiveFlag'" class="medical-info">
            <div class="label">{{ c.key }}</div>
            <div class="detail elip--multiple" style="-webkit-line-clamp: 1">
              {{ c.value || '--' }}
            </div>
          </div>
        </div>
        <RetreatmentInfo v-if="props.msgObject.reserveDate" :info="props.msgObject" />
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 病历详情 -->
    <div class="card" v-if="props.customEvent === '21003'">
      <div class="card-header">病历详情</div>
      <div class="card-body">我为你写了一份病历，点击可以就可以查看</div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 中药处方 -->
    <div class="card" v-if="props.customEvent === '22001'">
      <div class="card-header card-prescription-header">处方</div>
      <div class="card-body">
        <div class="card-flex">
          <auth-img class="medicine-img" src="@/assets/img/chat/drug.png" />
          <div>处方当日有效，且只能购买一次，失效后请重新咨询医生</div>
        </div>
        <RetreatmentInfo v-if="props.msgObject.reserveDate" :info="props.msgObject" />
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 联合处方 22110-->
    <!-- 身心临观二期上线后这条消息显示处方卡片消息,老得数据还是显示【处方待审核】 auditStatus旧的是没有这个字端的-->
    <template v-if="props.customEvent === '22111' && !isEmpty(props?.msgObject?.msgShowType)">
      <!-- TODO:待购工单AI语音优化 -->
      <PrescriptionCard
        @handleOpen="handleOpen"
        :info="props"
        :detailDrugs="detaiDrugs(props.msgObject)"
        @handleClick="handleClick"
      ></PrescriptionCard>
    </template>

    <!-- 身心临观二期上线后这条消息就成了定向消息（只发给患者端，其他端不显示） -->
    <template v-if="props.customEvent === '22110'">
      <PrescriptionCard
        :info="props"
        :detailDrugs="detaiDrugs(props.msgObject)"
        @handleClick="handleClick"
      ></PrescriptionCard>
    </template>
    <!-- 西药处方 22002-->
    <div class="card" v-if="props.customEvent === '22002'">
      <div class="card-header">处方</div>
      <div class="card-body">
        <div>医生根据您的症状描述推荐您服用以下商品</div>
        <div class="auxiliary" v-for="(c, index) in toJson(props.msgObject.items)" :key="c.skuId">
          <span v-if="index < 4">{{ c.productName }}</span>
          <div style="color: #3b3b3b" v-if="index < 4">{{ c.usage }}</div>
          <span v-if="index === 4">...</span>
        </div>
        <div style="margin-top: 8px">处方当日有效，且只能购买一次，失效后请重新咨询</div>
        <RetreatmentInfo v-if="props.msgObject.reserveDate" :info="props.msgObject" />
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 健康辅助方 22003-->
    <div class="card" v-if="props.customEvent === '22003'">
      <PStatusLabel :info="props.msgObject" />
      <div class="card-header">健康辅助方</div>
      <div class="card-body">
        <div>医生根据您的症状描述推荐您服用以下商品</div>
        <div class="auxiliary" v-for="(c, index) in toJson(props.msgObject.items)" :key="c.skuId">
          <span v-if="index < 4">{{ c.skuName }}</span>
          <span v-if="index === 4">...</span>
        </div>
      </div>
      <!-- <div @click="handleClick" class="card-footer">查看详情</div> -->
      <div class="card-footer-flex">
        <div @click="handleClick" class="btn">查看详情</div>
        <!-- 待购工单AI语音优化  -->
        <div v-if="props.msgObject.chatSummaryId" @click="handleOpen" class="btn">未购原因</div>
      </div>
    </div>
    <!-- 处方作废 22004 -->
    <div class="card" v-if="props.customEvent === '22004'">
      <div class="card-header">
        {{ props.msgObject?.prescriptionType === '3' ? '健康辅助方作废' : '处方作废' }}
      </div>
      <div class="card-body error">
        {{ props.msgObject.content }}
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 续方申请拒绝 22005 -->
    <div class="card" v-if="props.customEvent === '22005'">
      <div class="card-header">续方失败</div>
      <div class="card-body error">
        {{ props.msgObject.processRemark }}
      </div>
    </div>
    <!-- 随访计划 医生发起：23001 健康管家发起：23002 系统发起：23005-->
    <div
      class="card"
      v-if="['23001', '23002', '23005', '23008', '23009'].includes(props.customEvent)"
    >
      <div class="card-header">随访量表</div>
      <div class="card-body">
        <div class="medical-info">
          <div class="label">量表名称：</div>
          <div class="detail">{{ props.msgObject.formTitle }}</div>
        </div>
        <div class="medical-info">
          <div class="label">发送时间：</div>
          <div class="detail">{{ props.msgObject.formTime }}</div>
        </div>
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 随访量表患者发送 23003 -->
    <div class="card" v-if="props.customEvent === '23003'">
      <div class="card-header">随访结果</div>
      <div class="card-body">
        <div class="medical-info">
          <div class="label">量表名称：</div>
          <div class="detail">{{ props.msgObject.formTitle }}</div>
        </div>
        <div class="medical-info">
          <div class="label">量表结果：</div>
          <div class="survey-result">{{ props.msgObject.formResult }}</div>
        </div>
        <div class="medical-info">
          <div class="label">发送时间：</div>
          <div class="detail">
            {{ moment(Number(props.msgObject.formSendTime)).format(format) }}
          </div>
        </div>
        <div class="medical-info">
          <div class="label">提交时间：</div>
          <div class="detail">
            {{ moment(Number(props.msgObject.formSubmitTime)).format(format) }}
          </div>
        </div>
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 医生助手发送检查单提醒 27002 -->
    <div class="card" v-if="props.customEvent === '27002'">
      <div class="card-header">检查单</div>
      <div class="card-body">您好！为了帮助了解您的病情变化和用药疗效，请上传检查单报告</div>
    </div>
    <!-- 患者上传的检查单 27003 -->
    <div class="card" v-if="props.customEvent === '27003'">
      <div class="card-header">检查单</div>
      <div class="card-body">
        <div class="medical-info">
          <div class="label">上传时间：</div>
          <div class="detail">{{ props.msgObject.uploadTime }}</div>
        </div>
      </div>
      <div v-if="props.msgObject.urls" class="medical-img">
        <auth-img
          mode="ant"
          v-for="(url, index) in toJson(props.msgObject.urls).slice(0, 3)"
          :key="index"
          :width="68"
          :height="68"
          :src="url"
        />
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <div class="card" v-if="props.customEvent === '27004'">
      <div class="card-header">病情描述</div>
      <div class="card-body">
        <div class="body_content" style="-webkit-line-clamp: 4">
          {{ props?.msgObject?.descriptionContent }}
        </div>
        <div style="margin-top: 12px">
          <img-list
            :images="props?.msgObject?.images?.length > 0 ? JSON.parse(props.msgObject.images) : []"
          />
        </div>
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 医生发送的线下处方观察 27001 -->
    <div class="card" v-if="props.customEvent === '27001'">
      <div class="card-header">线下处方观察</div>
      <div class="card-body">
        <div class="medical-info">
          <div class="label">上传时间：</div>
          <div class="detail">{{ props.msgObject.createdAt || '--' }}</div>
        </div>
      </div>
      <div v-if="props.msgObject.prescriptionPicUrls" class="medical-img">
        <auth-img
          mode="ant"
          v-for="(url, index) in toJson(props.msgObject.prescriptionPicUrls).slice(0, 3)"
          :key="index"
          :width="68"
          :height="68"
          :src="url"
        />
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 医生指导意见 23004 -->
    <div class="card" v-if="props.customEvent === '23004'">
      <div class="card-header">指导建议</div>
      <div class="card-body">医生对患者提交的问卷进行了指导，点击进行查看</div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 复诊提醒 23006 -->
    <div class="card" v-if="props.customEvent === '23006'">
      <div v-if="props.msgObject.itemType === '2'">
        <div class="card-header">复诊提醒</div>
        <div class="card-body">{{ props.msgObject.remindContent }}</div>
        <div @click="handleClick" class="card-footer">查看详情</div>
      </div>
      <div v-else>
        <div>复诊提醒：</div>
        <div>{{ props.msgObject.remindContent }}</div>
      </div>
    </div>
    <!-- 金华医院预约单 -->
    <div class="card" v-if="props.customEvent === '50607'">
      <div class="card-header">预约挂号单</div>
      <div class="card-body">
        <div>
          <span class="label">就诊时间:</span>
          {{ props.msgObject.reserveDate }}
        </div>
        <div>
          <span class="label">就诊医院:</span>
          {{ props.msgObject.hospitalName }}
        </div>
        <div>
          <span class="label">就诊科室:</span>
          {{ props.msgObject.departmentName }}
        </div>
        <div s>
          <span class="label">医生姓名:</span>
          {{ props.msgObject.doctorName }}
        </div>
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 复诊提醒患者填写完成 23007 -->
    <div class="card" v-if="props.customEvent === '23007'">
      <div class="card-header">复诊提醒</div>
      <div class="card-body"></div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <MedicalRecordDetail
      v-model:visible="medicalVisible"
      :recordType="recordType"
      :id="recordId"
      :recordIsPre="recordIsPre"
    />
    <!-- 随访量表弹窗 -->
    <Gauge ref="gDetail" :params="detailQuery" />
    <!-- 复诊预约卡片 BD/健管推送预约链接-->
    <div class="card" v-if="props.customEvent === '29003'">
      <div class="card-header">复诊预约</div>
      <div class="card-body">您好！请选择门诊就诊时间，以便于为您预约医生门诊时间</div>
    </div>
    <!-- 复诊预约卡片 患者提交复诊预约申请-->
    <div class="card" v-if="['29006', '29004', '29009', '29010'].includes(props.customEvent)">
      <div class="card-header">
        {{ renderReverseDesc(props.customEvent, props.msgObject.customDesc) }}
      </div>
      <div class="card-body">
        <div class="medical-info">
          <div class="label">就诊医院：</div>
          <div class="detail">{{ props.msgObject.hospitalName }}</div>
        </div>
        <div class="medical-info">
          <div class="label">就诊医生：</div>
          <div class="detail">{{ props.msgObject.doctorName }}</div>
        </div>
        <div class="medical-info">
          <div class="label">就诊时间：</div>
          <div class="detail">
            {{ handleTimeShowWeek(props.msgObject.reserveDate.split(' ')[0])
            }}{{ props.msgObject.reserveDate.split(' ')[1] }}
          </div>
        </div>
        <div @click="handleClick" class="card-footer">查看详情</div>
      </div>
    </div>
    <!-- 医生指导意见 29002 -->
    <div class="card" v-if="props.customEvent === '29002'">
      <div class="card-header">健康信息</div>
      <div class="card-body">请患者填写健康信息，以便医生快速了解情况</div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 沟通小结/AI问诊小结 29005 -->
    <div class="card" v-if="props.customEvent === '29005'">
      <a-popover
        v-model:visible="aiRecallVisible"
        trigger="contextmenu"
        placement="right"
        @visibleChange="changeAiRecall"
      >
        <div class="card-header">
          <div class="header-fixed">
            {{ hasAITag ? '问诊小结' : '沟通小结内容' }}
            <div class="head-tag" v-if="aiSummary">预问诊小结</div>
          </div>
        </div>
        <div class="card-body" style="word-wrap: break-word">
          <span class="ellipsis-4">{{ props.msgObject.contents }}</span>
          <div v-if="hasAITag || aiSummary" class="ai-tag">内容由AI生成</div>
        </div>
        <div @click="handleClick" class="card-footer">查看详情</div>
        <template #content>
          <a style="color: #666666" @click="recalMessage()">撤回</a>
        </template>
      </a-popover>
    </div>
    <!-- 快捷链接 50901 -->
    <div v-if="props.customEvent === '50901'">
      <QuickLinkDialogue
        :content-text="props.msgObject.textContent"
        :btn-name="JSON.parse(props.msgObject.toPatientEvents)[0].eventName"
        :isBySelf="props.isBySelf"
      />
    </div>
    <div class="card" v-if="props.customEvent === '29011'">
      <div class="card-header">沟通小结内容</div>
      <div class="card-body" style="word-wrap: break-word">
        <div class="contentsJson">
          <div
            v-for="(item, index) in GuideLablesConfigNoImg"
            :key="index"
            style="margin-bottom: 6px"
          >
            <span class="label">{{ item.label }}：</span>
            <span>{{ JSON.parse(props.msgObject.contents)[item.key] || '--' }}</span>
          </div>
        </div>
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 锦旗 29101 -->
    <div class="card" v-if="props.customEvent === '29101'">
      <div class="card-header">
        赠送
        <label style="color: #ffa940">“{{ props.msgObject.pennantTitle }}”</label>
        锦旗一面
      </div>
      <div class="card-body">
        <div class="pennants">
          <auth-img class="flag" :width="140" :src="props.msgObject.pennantUrl" alt="" />
          <span>赠送人：{{ props.msgObject.rewardName }}</span>
        </div>
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 29020 双方都确认 -->
    <!-- 29021 待医生确认复诊预约单-->
    <!-- 29022 待患者确认复诊预约单 BD发起的预约单场景-->
    <!-- 29023 待患者确认复诊预约单医生主动上传补充诊疗记录-->
    <!-- 29024 待患者确认复诊预约单(29022保留当时后端不会推，新增29024)-->
    <div
      class="card"
      v-if="['29020', '29021', '29022', '29023', '29024'].includes(props.customEvent)"
    >
      <div class="card-header">复诊预约单</div>
      <div class="card-body">
        <div>
          复诊时间：{{ handleTimeShowWeek(props.msgObject.reserveDateStr) }}
          {{ ['上午', '下午'][Number(props.msgObject.reserveDateDetail) - 1] }}
        </div>
        <div>
          复诊方式：{{ ['线上问诊', '门诊就诊'][Number(props.msgObject.revisitType) - 1] || '--' }}
        </div>
        <div style="display: flex" v-if="props.msgObject.remark">
          <div class="twoText">
            <div>备</div>
            注：
          </div>
          <text>{{ props.msgObject.remark }}</text>
        </div>
      </div>
      <div @click="handleClick" class="card-footer">查看详情</div>
    </div>
    <!-- 售后消息 -->
    <template v-if="['51000'].includes(props.customEvent)">
      <ReturnGoodsCard :msg="props.msgObject" @handleClick="handleClick" />
    </template>
    <template v-if="['52002'].includes(props.customEvent)">
      <ConfirmAddressCard :msg="props.msgObject" />
    </template>
    <!-- 补充诊疗记录 -->
    <div class="card" v-if="props.customEvent === '21020'">
      <div class="card-header">补充诊疗记录</div>
      <div class="card-body">
        请及时上传门诊诊疗记录，便于医生掌握您的疾病情况，我们将为您提供全病程服务。
      </div>
      <div @click="handleClick" class="card-footer">帮患者补充</div>
    </div>
    <!-- AI消息 -->
    <AICard
      :msgBody="props.msgBody"
      :msg="props.msgObject"
      v-if="['50800', '50801', '50804'].includes(props.customEvent)"
    >
      <template #action>
        <AiBtns :msg="props.msgObject" />
      </template>
    </AICard>
    <!-- 新五要素-->
    <template v-if="props.customEvent === '53001'">
      <FiveElements :msg="props.msgObject" />
    </template>
    <!--  引导入群-->
    <template v-if="props.customEvent === '53000'">
      <GuideJoinGroup
        :msg="{
          ...props.msgObject,
          conTitle: props.msgObject.title
        }"
      />
    </template>
    <!-- 企微聊天记录-->
    <template v-if="props.customEvent === '53002'">
      <EnterpriseWeChatRecord :msg="props.msgObject" />
    </template>
    <!-- 医生群发 文件类型消息卡片 -->
    <template v-if="props.customEvent === '29800'">
      <FilesCard :msg="props.msgObject" />
    </template>
    <!-- 推荐医生卡片消息 -->
    <RecommendDocCard v-if="props.customEvent === '29201'" :info="props.msgObject" />
    <!-- 追溯码引导 -->
    <div
      class="trace-code"
      :class="{ 'feedback-style': props.customEvent === '29605' }"
      v-if="props.customEvent === '29602' || props.customEvent === '29605'"
    >
      <div
        v-if="props.customEvent === '29605' && props.msgObject.description"
        class="trace-code-desc"
      >
        {{ props.msgObject.description }}
      </div>
      <auth-img :src="traceCodeImg" />
    </div>
    <div v-if="props.customEvent === '29606'">
      <PrescriptionUploadSuccess :msg="props.msgObject" />
    </div>
    <div v-if="props.customEvent === '22114'" class="recommend-card">
      <div class="title">推荐医生开具处方</div>
      <div class="medical-info">
        <div class="medical-title">药品：</div>
        <div class="medical-content">
          <div class="medicine" v-for="item in recommendDrugList" :key="item.key">
            <template v-if="item.type === 'chinese'">中药处方</template>
            <template v-else-if="item.type === 'more'">...</template>
            <template v-else>
              <span>{{ item.skuName }}</span>
              <div v-if="item.skuNum !== undefined" style="color: #3b3b3b">{{ item.skuNum }}</div>
            </template>
          </div>
        </div>
      </div>
      <div class="btn" @click="handleClick">查看详情</div>
    </div>
    <!-- 用药提醒 -->
    <div
      v-if="['50504'].includes(props.customEvent)"
      class="medication-reminder"
      v-html="formatContent(props.msgObject.content)"
    ></div>
    <!-- 锦旗弹窗 -->
    <pennants ref="pennantsPayload" :pennantsId="pennantsId" />
    <!-- 沟通小结 -->
    <a-modal
      :title="summaryPanneltitle"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
    >
      <summaryPannel
        :chatSummaryId="props.msgObject.chatSummaryId"
        @closeSummaryModal="summaryPanelVisible = false"
      />
    </a-modal>
    <!-- 复诊预约弹窗 -->
    <ADetail ref="aDetail" :recordId="appointId" />
    <!-- 检查单弹窗 -->
    <a-modal
      v-model:visible="checklistvisible"
      :width="1059"
      title="检查单详情"
      :bodyStyle="{
        padding: '16px 24px 18px 24px'
      }"
      :footer="null"
    >
      <checklistDetail
        :checklistId="props.msgObject.checklistId"
        :visible="checklistvisible"
      ></checklistDetail>
    </a-modal>
    <!-- 线下处方弹窗 -->
    <the-detail
      v-model:visible="theDetailVisible"
      :id="prescriptionId"
      :serialNumber="serialNumber && serialNumber.length === 1 ? '' : serialNumber"
      :recordType="recordType"
    />
    <!-- 疗效跟踪 -->
    <div class="card cardNoBottom" v-if="['29301', '29302'].includes(props.customEvent)">
      <div class="card-header">
        {{ handleEffectTittle(props.customEvent) }}
        <div v-if="props.customEvent === '29301'" class="card-content">
          医生和我们都很关心您近期的情况，方便的时候反馈一下您的最新情况，我和医生会根据反馈及时调整您的诊疗方案。
        </div>
      </div>
      <div class="card-body">
        <CurativeTrack
          :trackConfig="props.msgObject"
          :eventCode="props.customEvent"
          :isGroup="props.isGroup"
        />
      </div>
    </div>
    <!-- 疗效反馈 -->
    <div class="card cardNoBottom" v-if="['29501', '29502'].includes(props.customEvent)">
      <div class="card-header">
        {{ handleFeedBackTittle(props.customEvent) }}
        <div v-if="props.customEvent === '29501'" class="card-content">
          医生和我们都很关心您近期的情况，方便的时候反馈一下您的最新情况，我和医生会根据反馈及时调整您的诊疗方案。
        </div>
      </div>
      <div class="card-body">
        <CurativeFeedBack
          :trackConfig="props.msgObject"
          :eventCode="props.customEvent"
          :isGroup="props.isGroup"
        />
      </div>
    </div>
    <!-- 疾病推送量表 -->
    <IllnessPush v-if="['23010'].includes(props.customEvent)" :IMConfig="props.msgObject" />
    <!-- 导诊结果卡片 -->
    <div class="card" v-if="props.customEvent === '29008'">
      <div class="card-header">导诊结果</div>
      <GuideResultCard :contents="props.msgObject.contents" />
    </div>
    <!-- 文章卡片 -->
    <Article
      v-if="props.customEvent === '29601'"
      :url="props.msgObject.articleImageUrl"
      :title="props.msgObject.articleTitle"
      :link="props.msgObject.articleLink"
    />
  </div>
  <!-- 卡片底部提示 -->
  <div v-if="['29020', '22111'].includes(props.customEvent)" class="msg_tips">
    <div :class="[getMsgTipsConfig(props).className]" v-if="getMsgTipsConfig(props).content">
      <auth-img :src="getMsgTipsConfig(props).icon" class="icon" alt="" />
      {{ getMsgTipsConfig(props).content }}
    </div>
  </div>
  <!-- 问卷结果iframe -->
  <Info ref="infoRef" :url="scaleResultsUrl"></Info>
  <IllnessDesc :info="props.msgObject" ref="illnessDescRef"></IllnessDesc>
  <ConsultCardInfo ref="consultCardInfoRef" :info="props.msgObject"></ConsultCardInfo>
</template>

<script setup>
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { defineProps, ref, reactive, nextTick, defineEmits, computed, createVNode } from 'vue'
import { handleTimeShowWeek } from '@/utils/index'
import checklistDetail from '@/views/HealthRecord/checklistDetail.vue'
import PrescriptionCard from '../../components/PrescriptionCard'
import Config from '@/config/index'
import MedicalRecordDetail from '@/components/TheDetail'
import Gauge from '@/views/WorkPlace/Container/Gauge/components/gDetail'
import moment from 'moment'
import TheDetail from '@/components/TheDetail/index.vue'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import pennants from './pennants.vue'
import { subStringToType } from '@/utils/index'
import { useRouter } from 'vue-router'
import summaryPannel from '../summaryPannel/index.vue'
import RecommendDocCard from './recommendCard.vue'
import CurativeTrack from './curativeTrack.vue'
import CurativeFeedBack from './curativeFeedBack.vue'
import IllnessPush from './illnessPush.vue'
import RetreatmentInfo from '../retreatment/cardRetreatInfo.vue'
import GuideResultCard from './guideResultCard.vue'
import { GuideLablesConfigNoImg } from '@/views/WorkPlace/Container/chat/components/message/config.js'
import { getMsgTipsConfig, AuditStatus } from './config'
import { message, Modal } from 'ant-design-vue'
import Info from '../ScaleResults/Info.vue'
import { isEmpty } from '@/utils'
import PStatusLabel from '../PStatusLabel/index.vue'
import AICard from './AICard/index.vue'
import AiBtns from './AICard/btns/index.vue'
import ReturnGoodsCard from './ReturnGoodsCard/index.vue'
import ConfirmAddressCard from './ConfirmAddressCard/index.vue'
import FilesCard from './FilesCard/index.vue'
//import ImportantTask from './ImportantTask/index.vue'
import Article from './Article/index.vue'
import PrescriptionUploadSuccess from './PrescriptionUploadSuccess.vue'
import TraceCodeCard from './traceCodeCard.vue'

import { useStore } from 'vuex'

const store = useStore()
const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
import ImgList from './ImgLIst/index.vue'
import IllnessDesc from './IllnessDesc/index.vue'
import ConsultCard from './ConsultCard/index.vue'
import ConsultCardInfo from './ConsultCard/consultCardInfo.vue'
import { getStateById, messageRecall } from '@/api/chat'
import {
  QuickLinkDialogue,
  GuideJoinGroup,
  EnterpriseWeChatRecord
} from '@/views/WorkPlace/Container/chat/components'

const consultCardInfoRef = ref(null)
const illnessDescRef = ref(null)
const infoRef = ref(null)
const scaleResultsUrl = ref('')
const router = useRouter()
const format = 'YYYY.MM.DD HH:mm'
//线下处方观察处方笺号
// const { serialNumber = '' } = workInfo
const serialNumber = ref('')
//西药 中药 辅助方
// const prescriptionVisible = ref(false)
const recordType = ref('')
const prescriptionId = ref(-1)
const recordIsPre = ref('')
//电子病历 门诊病历
const medicalVisible = ref(false)
const recordId = ref('')

//线下处方详情弹窗
const theDetailVisible = ref(false)

// 沟通小结弹窗
const summaryPanelVisible = ref(false)
const summaryPanneltitle = ref('')
// 锦旗弹窗
const pennantsId = ref('')
const pennantsPayload = ref(null)

//量表
const detailQuery = reactive({
  surveyId: null,
  surveySendId: null
})

// 复诊预约
const aDetail = ref(null)
const appointId = ref('')

//检查单
const checklistvisible = ref(false)
const gDetail = ref(null)

// 追溯码引导图片
const traceCodeImg = computed(() =>
  props.customEvent === '29602'
    ? props.msgObject.warmlyScanType === '0'
      ? '@/assets/img/trace_code.png'
      : '@/assets/img/trace_code_result.png'
    : props.msgObject.warmlyScanType === '0'
    ? '@/assets/img/trace_code_feedback.png'
    : '@/assets/img/trace_code_result_feedback.png'
)

// 外部方法
const emits = defineEmits(['chatEvents'])
const handleClick = () => {
  const { msgObject = {}, customEvent = '' } = props
  //prescription 处方  health 辅助方
  //onLineRecord 电子病历 offLineRecord 就医记录
  switch (customEvent) {
    case '51000':
      window.open(
        process.env.VUE_APP_CMS_URL +
          `/orderv1Manage/afterSalesOrder/detail/${msgObject.postsaleSn}`
      )
      break
    case '50021':
      consultCardInfoRef.value.initData()
      break
    case '22002':
      // 西药
      // R:线上处方  H:健康辅助方  HR:线下处方
      serialNumber.value = ''
      recordType.value = subStringToType('R')
      prescriptionId.value = msgObject.recommandId
      theDetailVisible.value = true
      break
    case '22001':
      // 中药
      // R:线上处方  H:健康辅助方  HR:线下处方
      serialNumber.value = ''
      recordType.value = subStringToType('R')
      prescriptionId.value = msgObject.recommandId
      theDetailVisible.value = true
      break
    case '22003':
      // 辅助方
      // R:线上处方  H:健康辅助方  HR:线下处方
      serialNumber.value = ''
      recordType.value = subStringToType('H')
      prescriptionId.value = msgObject.prescriptionId
      theDetailVisible.value = true
      break
    case '22004':
      //处方作废
      serialNumber.value = msgObject.prescriptionType === '0' ? msgObject.serialNumber : ''
      recordType.value = subStringToType(msgObject.serialNumber)
      prescriptionId.value =
        msgObject.prescriptionType === '0' ? msgObject.serialNumber : msgObject.recomId
      theDetailVisible.value = true
      break
    case '22110':
      // 联合处方
      serialNumber.value = msgObject.parentInstanceSn
      recordType.value = 'prescriptionGroup'
      theDetailVisible.value = true
      break
    case '22111':
      // 联合处方
      // 审核中给提示
      if (msgObject.auditStatus === AuditStatus.auditing) {
        return message.warning('处方审核中 (约10～15秒)，通过后即可查看')
      }
      serialNumber.value = msgObject.parentInstanceSn
      recordType.value = 'prescriptionGroup'
      theDetailVisible.value = true
      break
    case '22113':
      // 联合处方
      serialNumber.value = msgObject.prescriptionSn
      recordType.value = 'prescriptionGroup'
      theDetailVisible.value = true
      break
    case '22114':
      // 推荐医生卡片
      getStateById({ id: msgObject.advanceMedicalRecordId }).then(res => {
        const { recordState, prescriptionSendState, prescriptionSn } = res
        // recordState - 预病历状态，0：待确认 1：已确认 2：驳回 3：已失效
        // prescriptionSendState - 关联处方发送状态，0：未发送 1：已发送；无关联处方时为空
        if (recordState === 1 && prescriptionSendState === 1) {
          serialNumber.value = prescriptionSn
          recordType.value = 'prescriptionGroup'
          theDetailVisible.value = true
        } else {
          message.info('处方审核中，预计3分钟完成，请稍等')
        }
      })
      break
    case '21003':
      recordType.value = 'onLineRecord'
      recordId.value = msgObject.medicalRecordId
      medicalVisible.value = true
      break
    case '21002':
      recordType.value = 'offLineRecord'
      recordId.value = msgObject.id || -1
      medicalVisible.value = true
      recordIsPre.value = msgObject.jumpFlag
      break
    // case '23001':
    //   if (msgObject?.sendType === '4') {
    //     return message.warning('当前量表暂不支持查看！')
    //   }
    //   detailQuery.surveyId = msgObject.formRecordId
    //   detailQuery.surveySendId = msgObject.formSendId
    //   gDetail.value.gDetailVisible = true
    //   break
    // case '23002':
    //   if (msgObject?.sendType === '4') {
    //     return message.warning('当前量表暂不支持查看！')
    //   }
    //   detailQuery.surveyId = msgObject.formRecordId
    //   detailQuery.surveySendId = msgObject.formSendId
    //   gDetail.value.gDetailVisible = true
    //   break
    case '23001':
    case '23002':
    case '23003':
    case '23005':
    case '23008':
    case '23009':
      if (msgObject?.sendType === '4') {
        if (!msgObject?.formUrl) return message.warning('当前量表暂不支持查看！')
        scaleResultsUrl.value =
          customEvent === '23009'
            ? `${msgObject?.formUrl}&healthToken=${localStorage.getItem('token')}&surveyType=${
                msgObject?.surveyType
              }&doctorId=${curGroupInfo.value.doctorInfo?.businessId || 0}&patientId=${
                curGroupInfo.value.patientInfo?.businessId
              }`
            : `${msgObject?.formUrl}`
        return infoRef.value.showDrawer()
      }
      detailQuery.surveyId = msgObject.formRecordId
      detailQuery.surveySendId = msgObject.formSendId
      gDetail.value.gDetailVisible = true
      break
    case '23004':
      detailQuery.surveyId = msgObject.surveyRecordId
      detailQuery.surveySendId = msgObject.surveySendId
      gDetail.value.gDetailVisible = true
      break
    // case '23005':
    //   if (msgObject?.sendType === '4') {
    //     return message.warning('当前量表暂不支持查看！')
    //   }
    //   detailQuery.surveyId = msgObject.formRecordId
    //   detailQuery.surveySendId = msgObject.formSendId
    //   gDetail.value.gDetailVisible = true
    //   break
    // case '23008':
    //   if (msgObject?.sendType === '4') {
    //     return message.warning('当前量表暂不支持查看！')
    //   }
    //   detailQuery.surveyId = msgObject.formRecordId
    //   detailQuery.surveySendId = msgObject.formSendId
    //   gDetail.value.gDetailVisible = true
    //   break
    case '23006':
      detailQuery.surveyId = msgObject.surveyId
      detailQuery.surveySendId = msgObject.surveySendId
      gDetail.value.gDetailVisible = true
      break
    case '27003':
      checklistvisible.value = true
      break
    case '27004':
      illnessDescRef.value.showDrawer()
      break
    // 线下处方观察卡片
    case '27001':
      recordType.value = subStringToType('HR')
      prescriptionId.value = msgObject.prescriptionOfflineId
      serialNumber.value = msgObject.serialNumber
      theDetailVisible.value = true
      break
    // 复诊预约详情 + 新的预约单
    case '29004':
    case '29006':
    case '29009':
    case '29010':
    case '29020':
    case '29021':
    case '29022':
    case '29024':
    case '29023':
    case '50607':
      // appointId.value = msgObject.id.toString()
      appointId.value = msgObject.reserveId
      nextTick(() => {
        aDetail.value.mVisible = true
        aDetail.value.initDetail()
      })
      break
    case '29002':
      router.push({
        path: '/healthInfo',
        query: { ucPatientId: msgObject.ucPatientId }
      })
      break
    case '29005':
      summaryPanelVisible.value = true
      summaryPanneltitle.value = hasAITag.value ? '问诊小结' : '沟通小结'
      break
    case '29011':
      summaryPanneltitle.value = '沟通小结'
      summaryPanelVisible.value = true
      break
    case '29101':
      pennantsId.value = msgObject.pennantRewardRecordId
      nextTick(() => {
        pennantsPayload.value.pennantsVisible = true
        pennantsPayload.value.pennantsInitDetail()
      })
      break
    case '21020':
      emits('chatEvents', '21020')
      break
    default:
      break
  }
}

const formatContent = content => {
  if (!content) return ''
  // 将 \n 替换为 <br> 标签
  return content.replace(/\\n/g, '<br>')
}
const handleOpen = () => {
  summaryPanelVisible.value = true
  summaryPanneltitle.value = '沟通小结'
}
const props = defineProps({
  isBySelf: {
    type: Boolean,
    required: false
  },
  msgObject: {
    required: true
  },
  customEvent: {
    type: String,
    required: true
  },
  msgBody: {
    type: Object,
    required: true
  },
  isGroup: {
    type: Boolean,
    required: false
  }
})
const medicalInfoList = [
  {
    key: '是否建档：',
    tag: 'archiveFlag',
    value: props.msgObject.archiveFlag
  },
  {
    key: '就诊诊断：',
    value: props.msgObject.offlineDiagnosis
  },
  {
    key: '处方药品：',
    value: props.msgObject.medicationNames
  }
]
const toJson = (str = '[]') => {
  const _str = JSON.parse(str)
  return _str
}
const recommendDrugList = computed(() => {
  const list = []
  if (props.msgObject.chineseMedicationItems) {
    const chineseItems = toJson(props.msgObject.chineseMedicationItems)
    if (chineseItems?.length > 0) {
      list.push({ type: 'chinese', key: 'chinese' })
    }
  }
  const skuList = toJson(props.msgObject.skuList)
  const prescriptionNames = toJson(props.msgObject.prescriptionNames)
  const healthProducts = toJson(props.msgObject.healthProducts)
  skuList.forEach(item => {
    list.push({ type: 'sku', key: item.skuId, skuName: item.skuName, skuNum: item.skuNum })
  })
  prescriptionNames.forEach((name, index) => {
    list.push({ type: 'prescription', key: `prescription-${index}`, skuName: name })
  })
  healthProducts.forEach(item => {
    list.push({ type: 'health', key: item.skuId, skuName: item.skuName })
  })
  if (list.length > 3) {
    return list.slice(0, 3).concat({ type: 'more', key: 'more' })
  }
  return list
})
const detaiDrugs = item => {
  const { skuList, healthProducts, prescriptionNames } = item
  // 西药
  const w = toJson(skuList).map(item => {
    return {
      name: item.skuName
    }
  })
  // 协定方
  const a = toJson(prescriptionNames).map(item => {
    return {
      name: item
    }
  })
  // 健康辅助方
  const h = toJson(healthProducts).map(item => {
    return {
      name: item.skuName
    }
  })
  const z = []
    .concat(w, a, h)
    .filter(item => item.name)
    .slice(0, 3)
  return z
}
const handleEffectTittle = type => {
  // 29301 疗效跟踪待评价 29302 疗效跟踪已评价
  if (type === '29301') {
    return '近期用药感受如何？'
  } else {
    return '疗效跟踪结果'
  }
}

const handleFeedBackTittle = type => {
  if (type === '29501') {
    return '近期用药感受如何？'
  } else {
    return '疗效反馈'
  }
}
const renderReverseDesc = (cusEvent, cusDesc) => {
  if (cusEvent === '29006') {
    return '复诊预约取消'
  } else if (cusEvent === '29004') {
    return '复诊预约结果'
  } else {
    return cusDesc
  }
}
const messageRecallTime = computed(() => store.state.user.imConfig.messageRecallTime)
const ucUserId = computed(() => store.getters.userId)
/**
 * businessType 定义
 * 1 导诊
 * 2 处方代购
 * 3 ai小结
 * 4 复诊跟踪
 * 5 复诊提醒
 * 6 患者私聊
 * 7 复诊不同意
 * 8 填写诊断及复诊日期
 */
const hasAITag = computed(() =>
  ['2', '3', '4', '5', '6', '7', '8'].includes(`${props.msgObject.businessType}`)
)

// 预问诊小结
const aiSummary = computed(() => ['11'].includes(`${props.msgObject.businessType}`))

// 撤回逻辑
const recalMessage = () => {
  const time = moment(props.msgBody.time)
  const curDate = moment()
  const timeDiff = curDate.diff(time, 'millisecond')
  // 判断是否设置了无限制撤回
  const isUnlimitedRecall = messageRecallTime.value === 0
  const msgBody = props.msgBody
  const msgId = msgBody.mid
  msgBody.operationUsers = msgBody.operationUsers || []
  // 撤回时间在 配置时间内
  if (!isUnlimitedRecall && (timeDiff > messageRecallTime.value || timeDiff < 0)) {
    Modal.warning({
      title: () => '该消息超过撤回时间，不能被撤回',
      okText: () => '确定'
    })
  } else {
    Modal.confirm({
      title: () => '确定撤回该条消息',
      icon: () => createVNode(ExclamationCircleOutlined),
      cancelText: () => '取消',
      okText: () => '确定',
      centered: true,
      onOk() {
        const params = { msgId: msgId }
        messageRecall(params).then(result => {
          msgBody.msgStatus = -1
          msgBody.operationUsers.push({
            ucUserId: ucUserId.value,
            role: 4,
            operationType: 3
          })
        })
      }
    })
  }
}
const aiRecallVisible = ref(false)
const changeAiRecall = val => {
  // 只有 hasAITag 时允许打开
  if (hasAITag.value) {
    aiRecallVisible.value = val
  } else {
    aiRecallVisible.value = false
  }
}
</script>
<style lang="scss" scoped>
@import '../../index.scss';

.msg_tips {
  .msg_tips_success {
    background: rgba(22, 192, 155, 0.08);
    border-radius: 6px;
    margin-top: 4px;
    font-weight: bold;
    font-size: 14px;
    color: #16c09b;
    padding: 8px 10px;
    display: flex;
    align-items: center;
  }
  .msg_tips_warning {
    background: rgba(255, 244, 234, 1);
    border-radius: 6px;
    margin-top: 4px;
    font-weight: bold;
    font-size: 14px;
    color: #ff992b;
    padding: 8px 10px;
    display: flex;
    align-items: center;
  }
  .icon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
}

.twoText {
  min-width: 70px;
  width: 70px;
  display: flex;
  justify-content: space-between;
}
.card-content {
  font-weight: 400;
  font-size: 15px;
  color: #1a1a1a;
  margin-top: 10px;
  line-height: 22px;
  opacity: 0.8;
}

.message-card {
  &.recommendCard {
    width: 351px;
  }
  &.widthAuto {
    width: auto !important;
  }
  .cardNoBottom {
    ::v-deep(.card-header) {
      border-bottom: 0;
      padding: 12px 12px 0 12px;
    }
  }
  .header-fixed {
    display: flex;
    align-items: center;
    .head-tag {
      height: 23px;
      line-height: 23px;
      font-weight: 500;
      font-size: 12px;
      color: #3f64ff;
      padding: 0 6px;
      border-radius: 4px;
      background: #3f64ff14;
      margin-left: 8px;
    }
  }
  .flex-box {
    display: flex;
    .icon {
      width: 24px;
      height: 18px;
      // margin-right: 8px;
    }
    .drug-list {
      flex: 1;
      .auxiliary {
        font-weight: 500;
        font-size: 16px;
        color: #1c1c1c;
        margin: 0 0 0 8px;
        span {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .auxiliary-tips {
    font-weight: 400;
    font-size: 14px;
    color: #7d7d7d;
    padding: 8px 0;
  }
}
.message-card .chat_recommend_card {
  border-radius: 0;
  background: #ffffff;
}

.appointment-modal {
  color: #999;
}

.ellipsis-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.ai-tag {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-top: 4px;
}
.pennants {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff6eb;
  border-radius: 8px;
  padding: 12px 0;
  margin: 4px 0;
  .flag {
    margin-bottom: 7px;
  }
  span {
    font-weight: 400;
    font-size: 14px;
    color: #3b3b3b;
  }
}

.contentsJson {
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
  font-weight: 500;
}
.medication-reminder {
  padding: 10px 12px;
  white-space: pre-wrap;
}
.trace-code {
  width: 260px;
  img {
    width: 100%;
    height: 100%;
  }
}
.feedback-style {
  padding: 10px 12px 15px 12px;
  .trace-code-desc {
    margin-bottom: 10px;
  }
}
.recommend-card {
  .title {
    padding: 12px 16px;
    color: #1a1a1a;
    font-size: 18px;
    font-weight: 500;
    border-bottom: 1px solid #efefef;
  }
  .medical-info {
    display: flex;
    margin: 12px 12px 0 12px;
    padding: 12px;
    border-radius: 0 8px 8px 0;
    background: rgba(244, 174, 84, 0.1);
    border-left: 4px solid #f4ae54;
    .medical-title {
      flex-shrink: 0;
      color: #7d7d7d;
      font-size: 14px;
      font-weight: 400;
    }
    .medical-content {
      flex: 1;
      overflow: hidden;
      color: #3b3b3b;
      font-size: 14px;
      font-weight: 400;
      .medicine {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
  .btn {
    padding: 12px;
    text-align: center;
    color: #1890ff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
}
</style>
